import { getAppData } from '../../lib/api/common'
import { getCompaniesPage } from '../../lib/api/company'

import Layout from '../../components/layout/Layout'
import SeoMaticHead from '../../components/common/SeoMaticHead'
// import CompaniesList from '../../components/content/CompaniesList'
import PageHeader from '../../components/content/page/PageHeader'
import PageBuilder from '../../components/content/PageBuilder'
import { revalidateSeconds } from "../../lib/helpers/revalidateSeconds";

export type CompaniesProps = {
	page: any
	// companies: Array<any>
	app: any
}

export async function getStaticProps(context: any) {

	const app: any = await getAppData();
	const data: any = await getCompaniesPage(
		context.preview ? context.previewData?.token : undefined
	);

	return {
		props: {
			app: app ? app : null,
			page: data ? data.page : null,
			// companies: data ? data.companies : null,
		},
		revalidate: revalidateSeconds()
	}
}


export default function Companies(props: CompaniesProps) {

	const { page, app } = props

	return (
		<>
			<SeoMaticHead seo={page.seo} />
			<Layout
				appData={app}
				subHeader={[
					{
						id: page.id,
						title: page.title,
						uri: null
					}
				]}
			>
				<>

					<PageHeader page={page} />

					{/* Removed automatic listing of companies, using page builder instead */}
					{/*<CompaniesList sectors={companies?.length > 0 ? companies : null} />*/}

					<PageBuilder contentBlocks={page.pageBuilder} />
				</>
			</Layout>
		</>
	)
}

